"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var context_1 = require("../../context");
var Icons_1 = require("../Icons");
var MoreButton = function (props) {
    var trans = context_1.useSemantics().trans;
    var _a = props.label, label = _a === void 0 ? trans('optiiva::labels.more') : _a, dusk = props.dusk;
    return (react_1.default.createElement("button", { "data-dusk": dusk, type: "button", className: "text-blue hover:text-blue-dark focus:outline-none focus:text-blue-dark" },
        react_1.default.createElement("span", { className: "flex items-center" },
            react_1.default.createElement("span", { className: "text-sm uppercase leading-none font-medium" }, label),
            react_1.default.createElement("span", { className: "inline-flex items-center justify-center px-1 ml-2 rounded-full bg-blue h-4 w-4" },
                react_1.default.createElement(Icons_1.ChevronDown, { className: "text-white w-full" })))));
};
exports.MoreButtonChevron = function (props) {
    var dusk = props.dusk;
    return (react_1.default.createElement("span", { className: "inline-flex items-center justify-center px-1 ml-2 rounded-full bg-blue h-4 w-4" },
        react_1.default.createElement(Icons_1.ChevronDown, { className: "text-white w-full" })));
};
exports.default = MoreButton;
//# sourceMappingURL=index.js.map